<template>
  <nav class="flex overflow-hidden rounded-xl border border-gray-300 dark:border-gray-700" :aria-label="label" role="tablist" aria-orientation="horizontal">
    <button
      v-for="opcion in opciones"
      :key="opcion.valor"
      type="button"
      role="tab"
      :aria-selected="modelValue === opcion.valor"
      :class="modelValue === opcion.valor ? 'border-b-blue-600 text-blue-700 dark:text-blue-400' : 'border-b-transparent text-gray-500 dark:text-gray-400'"
      class="flex-1 cursor-pointer border-b-2 bg-white px-4 py-3 text-sm font-medium hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-blue-600 dark:bg-gray-800 dark:hover:bg-gray-700"
      @click="$emit('update:modelValue', opcion.valor)"
    >
      {{ opcion.etiqueta }}
    </button>
  </nav>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string
  opciones: { valor: string; etiqueta: string }[]
  label: string
}>()

defineEmits<{
  'update:modelValue': [valor: string]
}>()
</script>
